import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchCourseByIdArgs,
  FetchCoursesArgs,
} from '../api/types/courses.types';

import {
  fetchCourseStatistics,
  fetchCourseById,
  fetchCourses,
} from '../api/courses.api';

export const coursesQueryKeys = createQueryKeys('educationCourses', {
  fetchCourseById: ({ id, locale, organizationId }: FetchCourseByIdArgs) => ({
    queryFn: () => fetchCourseById({ id, locale, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchCourseStatistics: ({
    id,
    locale,
    organizationId,
  }: FetchCourseByIdArgs) => ({
    queryFn: () => fetchCourseStatistics({ id, locale, organizationId }),
    queryKey: [organizationId, id, 'statistics', locale],
  }),
  fetchCourses: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchCoursesArgs) => ({
    queryFn: () =>
      fetchCourses({ contentFilters, locale, organizationId, tableFilters }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchInfiniteCourses: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchCoursesArgs) => ({
    queryFn: (context?: { pageParam?: unknown }) =>
      fetchCourses({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
});
